import TrackingService from '@/services/tracking';
import { ShopDetailViewInfo } from '@/types';
import Image from '@/ui/Image';
import SlideBox from '@/components/SlideBox';
import Tab3 from '@/ui/Tab3';
import { getAsset } from '@/utils';
import { ApiPagingResponseData } from '@remodeling/base';
import { ConstructionCaseContent } from '@remodeling/content';
import React from 'react';
import styled from 'styled-components';
import HgTab from './HgTab';
import StoreTab from './StoreTab';
interface ParkContentProps {
  data: ShopDetailViewInfo;
  constructData?: ApiPagingResponseData<ConstructionCaseContent>;
  tabState: {
    code: string;
    name: string;
    index: number;
  };
  isLoading: {
    detailDataState: boolean;
    constructDataState: boolean;
  };
  setTabState: (value: { code: string; name: string; index: number }) => void;
  handleConstructionPopup: () => void;
  handleLinkOpen: (value: string) => void;
}

const ParkContent = ({
  data,
  constructData,
  setTabState,
  tabState,
  isLoading,
  handleConstructionPopup,
  handleLinkOpen,
}: ParkContentProps) => {
  return (
    <Container {...TrackingService.tagGTM('design_park_show_room')}>
      <ImageBox>
        {data?.header && (
          <SlideBox
            baseHeight={260}
            baseWidth={770}
            data={data?.header?.mainImages}
            hasPagination
            arrowType="lg"
            hasInfinite
            hasArrow
            gtmName="shop_info_main_images"
          >
            {({ width, height, item, index }) => (
              <Image
                src={`http:${item?.url}`}
                alt={`eventRollingBanner${index}`}
                width={width}
                height={height}
                objectFit="cover"
              />
            )}
          </SlideBox>
        )}
      </ImageBox>

      {!!data?.exhibitHallList && data?.exhibitHallList?.length > 1 && (
        <TabContainer>
          <Tab3
            data={data.exhibitHallList}
            currentValue={tabState.name}
            onClickHandler={(e, index) => setTabState({ ...e, index })}
            gtmName="exhibit_hall_tab"
          />
        </TabContainer>
      )}
      {isLoading.constructDataState && isLoading.detailDataState ? (
        <>
          {tabState.code !== 'HG' ? (
            <StoreTab
              tabName={tabState.name}
              handleLinkOpen={handleLinkOpen}
              constructData={constructData}
              handleConstructionPopup={handleConstructionPopup}
              data={data?.exhibitHallList?.[tabState.index]}
            />
          ) : (
            <HgTab data={data?.exhibitHallList?.[tabState.index]} />
          )}
        </>
      ) : (
        <LoadingBox>
          <Image
            src={getAsset('/assets/icons/loading-obj-new.gif')}
            height={'40px'}
            width="40px"
            alt="loadingIcon"
          />
        </LoadingBox>
      )}
    </Container>
  );
};

export default ParkContent;

const Container = styled.div`
  width: 100%;
`;

const ImageBox = styled.div`
  margin-bottom: 40px;
`;

const TabContainer = styled.div`
  display: flex;
  margin-top: 28px;
  margin-bottom: 40px;
`;

const LoadingBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 400px;
`;
